<div class="cart-popup-container" *ngIf="!isLoading">
    <div class="cart-popup-header">
        <mat-icon class="cart-icon">shopping_cart</mat-icon>
        <h2>Items in your cart</h2>
    </div>
    <p class="cart-popup-desc">
        You have <strong>{{ cartCount }} item(s)</strong> saved in your cart for <strong>{{ storeName }}</strong>.
        Would you like to continue where you left off, or start fresh?
    </p>
    <div class="cart-popup-actions">
        <button mat-raised-button color="primary" (click)="goToCart()">Go to Cart</button>
        <button mat-raised-button color="warn" (click)="clearCart()">Clear Cart</button>
    </div>
</div>


<div class="cart-popup-loading" *ngIf="isLoading">
    <p>Loading cart...</p>
</div>